import { createSelector } from 'reselect';
import { ApplicationState } from '../types';

const getSchools = ({ schools }: ApplicationState) => schools;

export const getAllSchools = createSelector(
  [getSchools],
  (schools) => schools?.schools
);

export const getAllSchoolList = createSelector(
  [getSchools],
  (schools) => schools?.schoolList
);

export const getIsSchoolListError = createSelector(
  [getSchools],
  (schools) => schools?.schoolListError
);
